import { enUS_TraceabilityResult } from './result';

export const enUS_Traceability = {
  ...enUS_TraceabilityResult
};
